export default __webpack_public_path__ + "static/media/Bangles.edb4bd2b.jpg";